import { regex_email, regex_num } from "../../../constants/regex";

export const FieldValues = ({ name, value }, setValues, { setInputErr }) => {
    if (['name', 'address', 'colony', 'city', 'state'].includes(name)) {
        if (value.length <= 100) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    } else if (['phone', 'number'].includes(name)) {
        if ((value === '' || regex_num.test(value)) && value.length <= 15) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    } else if (name === 'email') {
        if (value.length <= 120) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    } else if (name === 'postalCode') {
        if ((value === '' || regex_num.test(value)) && value.length <= 5) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    } else if (name === 'message') {
        if (value.length <= 200) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    } else if (name === 'url') {
        if (value.length <= 500) {
            setFieldValue({ name, value }, setValues);
            FieldErrors({ name, value }, setInputErr);
        }
    }
};

// establecer valor en campo
const setFieldValue = ({ name, value }, setValues) => {
    if (['name', 'address', 'colony', 'city', 'state', 'phone', 'email', 'postalCode'].includes(name))
        setValues((e) => ({
            ...e, [name]: value
        }));
    else if (['number', 'message'].includes(name))
        setValues((e) => ({
            ...e, links: {
                ...e.links,
                whatsapp: {
                    ...e.links.whatsapp,
                    [name]: value
                }
            }
        }));
    else if (name === 'url')
        setValues((e) => ({
            ...e, links: {
                ...e.links,
                facebook: {
                    ...e.links.facebook,
                    [name]: value
                }
            }
        }));
};

const FieldErrors = ({ name, value }, setInputErr) => {
    switch (name) {
        case 'name':
            setInputErr(e => ({
                ...e,
                name_err: (value.length < 11 ||
                    value.length > 100) ? true : false
            }));
            break;
        case 'phone':
            setInputErr(e => ({
                ...e,
                phone_err: (value.length < 5 ||
                    value.length > 15) ? true : false
            }));
            break;
        case 'email':
            setInputErr(e => ({
                ...e,
                email_err: (
                    value.length < 5 ||
                    value.length > 120 ||
                    !regex_email.test(value)
                ) ? true : false
            }));
            break;
        case 'address':
            setInputErr(e => ({
                ...e,
                address_err: (value.length < 5 ||
                    value.length > 100) ? true : false
            }));
            break;
        case 'postalCode':
            setInputErr(e => ({
                ...e,
                pc_err: (value.length !== 5 || !regex_num.test(value)) ? true : false
            }));
            break;
        case 'colony':
            setInputErr(e => ({
                ...e,
                colony_err: (value.length < 5 ||
                    value.length > 100) ? true : false
            }));
            break;
        case 'city':
            setInputErr(e => ({
                ...e,
                city_err: (value.length < 3 ||
                    value.length > 100) ? true : false
            }));
            break;
        case 'state':
            setInputErr(e => ({
                ...e,
                state_err: (value.length < 3 ||
                    value.length > 100) ? true : false
            }));
            break;
        case 'number':
            setInputErr(e => ({
                ...e,
                wsp_number_err: (value.length < 5 || value.length > 15) ? true : false
            }));
            break;
        case 'message':
            setInputErr(e => ({
                ...e,
                wsp_message_err: (value.length < 3 || value.length > 200) ? true : false
            }));
            break;
        case 'url':
            setInputErr(e => ({
                ...e,
                facebook_url_err: (value.length < 11 || value.length > 500) ? true : false
            }));
            break;
        default:
            break;
    };
};
